import { Injectable } from '@angular/core';
import { environment } from 'environment';

declare global {
  interface Window {
    _paq?: any[];
  }
}

@Injectable({ providedIn: 'root' })
export class MatomoInitService {
  constructor() {
    if (environment.enableMatomo) {
      this.initializeMatomo();
    }
  }

  private initializeMatomo(): void {
    const _paq = (window._paq = window._paq || []);
    _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
    _paq.push(["setCookieDomain", "*.rehabconnect.com"]);
    _paq.push(["setDomains", ["*.rehabconnect.com", "*.*.zrehabconnect.com"]]);
    _paq.push(["enableCrossDomainLinking"]);
    _paq.push(["setDoNotTrack", true]);
    _paq.push(["disableCookies"]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);

    const siteId = environment.matomo.siteId;
    const trackerUrl = environment.matomo.trackerUrl;

    _paq.push(["setTrackerUrl", `${trackerUrl}matomo.php`]);
    _paq.push(["setSiteId", siteId]);

    const d = document;
    const g = d.createElement("script");
    const s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = `${trackerUrl}matomo.js`;
    s.parentNode!.insertBefore(g, s);
  }
}
